import { render, staticRenderFns } from "./invoicetable.vue?vue&type=template&id=23cae389"
import script from "./invoicetable.vue?vue&type=script&lang=js"
export * from "./invoicetable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports